// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ba392040","796":"fc0521ac"}[chunkId] + ".chunk.js";
};